import React, { useState } from 'react';
import '../../styling/ImageGallery.css';

const ImageGallery = () => {
    const [hoveredIndex, setHoveredIndex] = useState(null);

    const handleMouseEnter = (index) => {
        setHoveredIndex(index);
    };

    const handleMouseLeave = () => {
        setHoveredIndex(null);
    };

    return (
        <div className='main'>
            <div className="gallery-card-wrapper">
                {/* Add a class 'first-card' to the first element */}
                <figure
                    className={`galley-card first-card ${hoveredIndex === 0 ? 'flex-2' : hoveredIndex !== null ? 'flex-1' : 'flex-2'}`}
                    onMouseEnter={() => handleMouseEnter(0)}
                    onMouseLeave={handleMouseLeave}
                >
                    <img src="/assets/hero-bg-images/bg-1.jpg" alt="" />
                </figure>

                {[1, 2, 3, 4].map((index) => (
                    <figure
                        key={index}
                        className={`galley-card ${hoveredIndex === index ? 'flex-2' : ''}`}
                        onMouseEnter={() => handleMouseEnter(index)}
                        onMouseLeave={handleMouseLeave}
                    >
                        <img src="/assets/hero-bg-images/bg-1.jpg" alt="" />
                    </figure>
                ))}
            </div>
        </div>
    );
};

export default ImageGallery;
